import React from "react"
import {Chip, makeStyles} from "@material-ui/core"
import {colors} from "@indebted/theme"

const useStyles = makeStyles((theme) => ({
	latitudeChip: {
		backgroundColor: colors.chipPrimaryBackground,
		color: "#d32f2f",
		border: "none",
		marginLeft: theme.spacing(2),
	},
}))

function SystemOfRecordChip({systemOfRecord}: {systemOfRecord: string}) {
	const classes = useStyles()

	switch (systemOfRecord) {
		case "Latitude":
			return <Chip label="Latitude" size="medium" classes={{root: classes.latitudeChip}} />
		case "Collect":
			return null
		default:
			return null
	}
}

export {SystemOfRecordChip}
